import React from 'react'
import Header from '../include/Header'
// import { Link } from 'react-router-dom'
import Footer from '../include/Footer'
function GrievanceRedressalPolicy() {
    return (
        <>
            <Header />
            <div className="page-header bg-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="page-header-box">
                                <h1 className="wow fadeInUp" data-cursor="-opaque">Grievance Redressal Policy</h1>
                              {/*   <nav className="wow fadeInUp" data-wow-delay="0.2s">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Grievance Redressal Policy</li>
                                    </ol>
                                </nav> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cta-box">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-box-content">
                                <div className="section-title">
                                    {/* <h5 className="wow fadeInUp">Merchant Legal entity name:</h5> */}
                                    {/* <h5 className="wow fadeInUp">Grievance Redressal Policy</h5> */}
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        At <b>Innosutra AI Private Limited,</b> we are committed to delivering a smooth, reliable, and user-friendly experience across our services. We take user concerns seriously and have established a structured grievance redressal mechanism to ensure timely and effective resolution of complaints.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">1. Grievance Officer Details</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        For any concerns, complaints, or legal queries, users may contact our designated Grievance Officer:
                                        <ul>
                                            <li>Name: Haresh Rathore</li>
                                            <li>Email: innosutraaiprivatelimited@gmail.com</li>
                                            <li>Phone: 9727555057</li>
                                            <li>Address: E-213, 21st Floor, ANA Avant Garde, WEH, Shivaji Chowk, Mira Road, Thane – 401107, Maharashtra, India</li>
                                        </ul>
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">2. How to Raise a Complaint</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        Users can submit their complaints or queries through:
                                        <ul>
                                            <li>Email communication</li>
                                            <li>Phone contact</li>
                                        </ul>
                                        Please include relevant details such as your name, contact information, and a clear description of the issue to help us resolve it efficiently.
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">3. Acknowledgement of Complaint</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        <ul>
                                            <li>All complaints will be acknowledged within <b>24 hours</b> of receipt.</li>
                                        </ul>
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">4. Resolution Timeline</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        <ul>
                                            <li>We aim to resolve all valid complaints within 15 days from the date of receipt.</li>
                                            <li>In case additional time is required due to the complexity of the issue, the user will be informed accordingly.</li>
                                        </ul>
                                    </p>
                                    <br /><br />
                                    <h5 className="wow fadeInUp">5. Commitment to Users</h5>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">
                                        Our goal is to ensure:
                                        <ul>
                                            <li>Transparent communication</li>
                                            <li>Fair and unbiased resolution</li>
                                            <li>Continuous improvement of our services based on user feedback</li>
                                        </ul>
                                        We value your trust and are dedicated to providing a responsive and responsible support system.
                                    </p>
                                    <br /><br />
                                </div>
                                <div className="cta-section-shape">
                                    <img src="/assets/images/section-bg-shape-1.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default GrievanceRedressalPolicy
